export const getAnalytics = ({ analytics }) => analytics;

export const getPendingAnalyticsEvents = (state) =>
  getAnalytics(state).pendingAnalytics;
